import React, { useEffect, useState } from 'react';

type Props = {
  content: string | React.ReactNode;
  type: 'info' | 'units_left' | 'unavailable' | 'hot_spot' | 'hot_spot_alt';
};

const classes = {
  info: 'bg-solar-surface-tertiary text-solar-inverted-primary text-sm',
  units_left: 'bg-solar-surface-tertiary text-solar-inverted-primary text-sm',
  unavailable: 'bg-solar-surface-inactive text-solar-secondary text-sm',
  hot_spot: 'bg-solar-surface-brand-ultramarine text-white font-rp-basetica text-xs',
  hot_spot_alt: 'bg-rp-daylight text-custom-black font-rp-basetica text-xs',
};

export default function ProductBanner({ content, type }: Props) {
  const [tagClass, setTagClass] = useState<string>('');

  useEffect(() => {
    setTagClass(classes[type]);
  }, [type]);

  return (
    <div
      className={`flex font-medium font-rp-pn-regular items-center justify-center leading-6 py-1 px-4 text-center w-full ${tagClass}`}
    >
      {content}
    </div>
  );
}
